import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useMemo, useState } from 'react';
import { useFlagState, useDerivedState } from '@deliveryhero/armor-system';
import { DateVector } from '../utils/DateVector';
import { TimeVector24 } from '../utils/TimeVector24';
export var useCommonDatePickerState = function useCommonDatePickerState(_ref, _ref2) {
  var internalValue = _ref.internalValue;
  var defaultMonthYearSelectorOpen = _ref2.defaultMonthYearSelectorOpen,
    currentDate = _ref2.currentDate,
    enableMonthYearPickerMode = _ref2.enableMonthYearPickerMode,
    defaultPickerDate = _ref2.defaultPickerDate;
  // the date range touched (pre-selected) by a user. It keeps the value until a user mashes "Ok"
  var _useState = useState(internalValue.clone()),
    _useState2 = _slicedToArray(_useState, 2),
    dirtyInternalValueVector = _useState2[0],
    setDirtyInternalValueVector = _useState2[1];
  useEffect(function () {
    setDirtyInternalValueVector(internalValue.clone());
  }, [internalValue]);
  // the date we have at the moment
  var currentDateVector = useMemo(function () {
    return DateVector.createFromLocalDate(currentDate);
  }, [currentDate]);
  var currentTimeVector = useMemo(function () {
    return TimeVector24.createFromDateVector(currentDateVector);
  }, [currentDateVector]);
  // the date which is displayed, but not yet selected or pre-selected
  var _useState3 = useState(dirtyInternalValueVector.dateStart ? dirtyInternalValueVector.dateStart.clone() : DateVector.createFromLocalDate(defaultPickerDate)),
    _useState4 = _slicedToArray(_useState3, 2),
    displayedDateVector = _useState4[0],
    setDisplayedDateVector = _useState4[1];
  useEffect(function () {
    if (defaultPickerDate) {
      setDisplayedDateVector(DateVector.createFromLocalDate(defaultPickerDate));
    }
  }, [defaultPickerDate]);
  var _useDerivedState = useDerivedState(function () {
      return dirtyInternalValueVector.dateStart ? TimeVector24.createFromDateVector(dirtyInternalValueVector.dateStart) : currentTimeVector;
    }, [dirtyInternalValueVector, currentTimeVector]),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
    timeSelectorValue = _useDerivedState2[0],
    setTimeSelectorValue = _useDerivedState2[1];
  var _useFlagState = useFlagState(defaultMonthYearSelectorOpen || enableMonthYearPickerMode),
    _useFlagState2 = _slicedToArray(_useFlagState, 5),
    monthYearSelectorOpen = _useFlagState2[0],
    onMonthYearSelectorToggle = _useFlagState2[4];
  return {
    dirtyInternalValueVector: dirtyInternalValueVector,
    setDirtyInternalValueVector: setDirtyInternalValueVector,
    timeSelectorValue: timeSelectorValue,
    setTimeSelectorValue: setTimeSelectorValue,
    displayedDateVector: displayedDateVector,
    setDisplayedDateVector: setDisplayedDateVector,
    currentDateVector: currentDateVector,
    monthYearSelectorOpen: monthYearSelectorOpen,
    onMonthYearSelectorToggle: onMonthYearSelectorToggle
  };
};